import Regular from './gloriola_std_regular-webfont.woff2'
import RegularI from './gloriola_std_regular_it-webfont.woff2'
import Medium from './gloriola_std_medium-webfont.woff2'
import MediumI from './gloriola_std_medium_it-webfont.woff2'
import Bold from './gloriola_std_bold-webfont.woff2'
import BoldI from './gloriola_std_bold_it-webfont.woff2'
import Light from './gloriola_std_light-webfont.woff2'
import LightI from './gloriola_std_light_it-webfont.woff2'

export const fontTypes = []

fontTypes.push({
  fontFamily: "'Gloriola STD'",
  src: `local('Gloriola STD'), url(${Regular}) format('woff2')`
})

fontTypes.push({
  fontFamily: "'Gloriola STD'",
  fontStyle: 'oblique',
  src: `local('Gloriola STD'), url(${RegularI}) format('woff2')`
})

fontTypes.push({
  fontFamily: "'Gloriola STD'",
  fontWeight: 600,
  src: `local('Gloriola STD'), url(${Medium}) format('woff2')`
})

fontTypes.push({
  fontFamily: "'Gloriola STD'",
  fontStyle: 'oblique',
  fontWeight: 600,
  src: `local('Gloriola STD'), url(${MediumI}) format('woff2')`
})

fontTypes.push({
  fontFamily: "'Gloriola STD'",
  fontWeight: 700,
  src: `local('Gloriola STD'), url(${Bold}) format('woff2')`
})

fontTypes.push({
  fontFamily: "'Gloriola STD'",
  fontStyle: 'oblique',
  fontWeight: 700,
  src: `local('Gloriola STD'), url(${BoldI}) format('woff2')`
})

fontTypes.push({
  fontFamily: "'Gloriola STD'",
  fontWeight: 300,
  src: `local('Gloriola STD'), url(${Light}) format('woff2')`
})

fontTypes.push({
  fontFamily: "'Gloriola STD'",
  fontStyle: 'oblique',
  fontWeight: 300,
  src: `local('Gloriola STD'), url(${LightI}) format('woff2')`
})
